import React from "react";
import Item from "./Item";
import { useTranslation } from 'react-i18next';

const findTable = (rewards, tableID) => {
    for(var i = 0; i < rewards.length; i++) {
        if(rewards[i].TableID === tableID) {
            return rewards[i].Entries;
        }
    }
}

const ItemDrops = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);
    const dropTable = findTable(props.dropTables, props.drops);
    const bonusTable = findTable(props.bonusTables, props.bonus);
    if(!bonusTable) return null;
    return (
        <>
        <strong>{"☆".repeat(props.level+1)}{t("ITEMDROPS")}:</strong>
        <ul>
        {
                dropTable.map((v, idx) => {
                    return props.level < v.Values.length && v.Values[props.level] > 0 ?
                    <li key={idx}><Item itemID={v.ItemID} prob={v.Values[props.level]} sign="%" /></li>
                    : null
                }
                )
            }
        </ul>
        <strong>{"☆".repeat(props.level+1)}{t("BONUSDROPS")}</strong>
        <ul>
        {
                bonusTable.map((v, idx) => {
                    return props.level < v.Values.length && v.Values[props.level] > 0 ?
                    <li key={idx}><Item itemID={v.ItemID} prob={v.Values[props.level]}  sign="x" /></li>
                    : null
                }
                )
            }
        </ul>
        </>
        )
}

export default ItemDrops;